export default "__VITE_ASSET__C5FM1hWv__"